import React from 'react';
import { withStyles, Paper, Typography } from '@material-ui/core';
import { ReactComponent as WelcomeImage } from 'assets/welcome.svg';

const styles = (theme) => ({
  root: {
    width: '100%',
    height: '80vh',
    display: 'flex',
    textAlign: 'center',
    alignItems: 'center',
  },
  content: {
    flex: 1,
    marginBottom: '10vh',
  },
  subHeading: {
    color: '#6b6c6f',
    fontWeight: 'normal',
  },
});

const Welcome = (props) => {
  const { classes } = props;
  return (
    <Paper className={classes.root}>
      <div className={classes.content}>
        <WelcomeImage />
        <Typography variant="h3">
          Welcome to SelfService, a Debitsuccess online portal.
        </Typography>
        <Typography variant="h4" className={classes.subHeading}>
          We make billing simpler for you!
        </Typography>
      </div>
    </Paper>
  );
};

export default withStyles(styles)(Welcome);
